import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { BadgeComponent } from '../ui/badge.component/badge.component';
import { ButtonComponent } from '../ui/button.component/button.component';


import { Project } from 'src/app/dto';
import { ProjectsService } from 'src/app/service/projects.service';

@Component({
  selector: 'app-project-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    BadgeComponent,
    ButtonComponent
  ],
  templateUrl: './project-detail.component.html'
})
export class ProjectDetailComponent implements OnInit {
  project?: Project;
  isLoading = signal<boolean>(true);
  error = false;

  constructor(private route: ActivatedRoute, private projectsService: ProjectsService) {

  }

  ngOnInit(): void {
    var slug: string = '';
    this.route.paramMap.subscribe(params => {
      slug = params.get('slug');
    });
    this.projectsService.getProjectFromFile(slug).subscribe({
      next: project => {
        console.log(project);
        this.project = project;
        this.isLoading.set(false);
      },
      error: () => {
        this.error = true;
        this.isLoading.set(false);
      }
    });
  }
}

